// الأزرار "الثابتة" بلوحة كل حساب قديم (أزرار بلوحته + الشريط العلوي) - المدير
// يكدر يشيل أي وحدة منها أو يرجّعها من واجهة صلاحية المستخدمين.
//
// كل زر إله معرّف ثابت:
//   box:<مفتاح>   = نفس بوكسات PERMISSION_BOXES (إجازة، فواتير...)
//   extra:<مفتاح> = زر خاص بواجهة معيّنة (المخزن، النظام المحاسبي...)
//   dash:<مسار>   = واجهة موظف بالشريط العلوي
// المعرّفات المشالة تنحفظ بالحساب (hiddenBuiltIns بالباك اند) - الزر يختفي من
// لوحته ومن الشريط، وصفحته تنقفل عليه (إلا إذا عنده نفس الصفحة من بوكس ثاني).
//
// إذا انضاف زر ثابت جديد للوحة حساب: ضيفه هنا ولفّه بـshowBuiltIn("...") بلوحته.
import { PERMISSION_BOXES, getCurrentProfile, permissionAllowsPath } from "./userProfile";

const exact = (path) => new RegExp(`^${path.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}$`);

// صفحات كل بوكس عند الحسابات القديمة (مسارات "مهامي" تختلف من حساب لحساب)
const BOX_PATHS = {
  canvasCost: [exact("/canvas-cost")],
  createInvoice: [exact("/invoice"), /^\/invoice\/edit\/[^/]+$/],
  invoices: [exact("/invoices"), /^\/invoice\/[^/]+$/, /^\/invoice\/edit\/[^/]+$/, /^\/invoice\/version\/edit\/[^/]+\/[^/]+$/],
  proposals: [exact("/proposals"), /^\/proposals\/[^/]+$/],
  directSale: [exact("/archived-direct")],
  drawingVideos: [exact("/story-videos")],
  siteVisit: [exact("/site-visit")],
  leads: [exact("/leads")],
  myTasks: ["/my-tasks", "/BaneenTasks", "/yusuf-tasks", "/KarinaTasks", "/tasks-rand", "/JumanaTasks", "/SaraTasks", "/maryam-tasks", "/farah-tasks", "/MaysaTasks"].map(exact),
  todo: [exact("/todo")],
  leaveRequest: [exact("/leave-request")],
  materialRequest: [exact("/material-request")],
  ordersAdmin: [],
};

// الأزرار الخاصة بواجهات معيّنة
export const EXTRA_ITEMS = {
  approval: { label: "طلبات الموافقة", icon: "✅", paths: [exact("/approval")] },
  accounting: { label: "النظام المحاسبي الذكي", icon: "🏛️", paths: [exact("/accounting")] },
  overtime: { label: "أوفر تايم", icon: "⏱️", paths: [] },
  allStageVideos: { label: "فيديوات كل المراحل", icon: "🎬", paths: [exact("/all-stage-videos")] },
  inventory: { label: "المخزن", icon: "📦", paths: [exact("/baneen-inventory")] },
  materialRequestsAdmin: { label: "طلبات المواد (إدارة)", icon: "📦", paths: [exact("/material-requests-admin")] },
  partnersInventory: { label: "مخزن الشركاء", icon: "📦", paths: [exact("/partners-inventory")] },
  secondaryPartners: { label: "مخزن الشركاء الثانويين", icon: "🏢", paths: [exact("/secondary-partners")] },
  customerSurvey: { label: "استبيان الزبون", icon: "🎨", paths: [/^\/customer-survey(\/.*)?$/] },
  socialMedia: { label: "إدارة منشورات التواصل الاجتماعي", icon: "📣", paths: [] },
  expenses: { label: "مصاريفي", icon: "💰", paths: [exact("/burhan-expenses")] },
  invoiceStats: { label: "إحصائيات الفواتير", icon: "📊", paths: [exact("/invoice-stats")] },
  workshopExpenses: { label: "مصاريف الورشة", icon: "💵", paths: [exact("/burhan-expenses")] },
  priceList: { label: "قائمة الأسعار", icon: "💰", paths: [exact("/price-list")] },
  // ارت تاتش: "إضافة طلب" صفحة وحدة (طلب جديد أو بيع مباشر باختيار) - نفس أزرار شريطها
  partnerOrder: { label: "إضافة طلب", icon: "➕", paths: [exact("/partner-order"), exact("/partner-add")] },
  partnerPrice: { label: "حساب سعر اللوحة", icon: "📏", paths: [exact("/partner-price")] },
};

const INVOICE_KEYS = ["createInvoice", "invoices", "proposals"];

// home = لوحته الأساسية (ما تنشال حتى ما ينقفل الحساب على نفسه)
const ACCOUNTS = {
  "Baneen@123": {
    home: "/Baneen",
    interfaces: [
      { label: "مياسة", path: "/maysa" },
      { label: "المصمم", path: "/designer" },
      { label: "المطبعة", path: "/print" },
      { label: "الورشة", path: "/burhan" },
      { label: "الرسام", path: "/mohamed" },
      { label: "جمانا", path: "/jumana" },
      { label: "المحاسب", path: "/accountant" },
    ],
    boxes: [...INVOICE_KEYS, "directSale", "canvasCost", "myTasks", "todo", "leaveRequest", "siteVisit", "leads", "ordersAdmin"],
    extras: [
      "approval",
      "accounting",
      "overtime",
      "allStageVideos",
      "inventory",
      "materialRequestsAdmin",
      "partnersInventory",
      "secondaryPartners",
      "customerSurvey",
    ],
  },
  "designer@123": {
    home: "/designer",
    interfaces: [],
    boxes: ["myTasks", "todo", "leaveRequest"],
    extras: ["socialMedia", "allStageVideos"],
  },
  "print@123": { home: "/print", interfaces: [], boxes: [], extras: [] },
  "art@1234": { home: "/burhan", interfaces: [], boxes: ["leaveRequest", "materialRequest"], extras: ["expenses"] },
  "mohamed@123": { home: "/mohamed", interfaces: [], boxes: ["leaveRequest", "materialRequest"], extras: [] },
  "halima@123": { home: "/halima", interfaces: [], boxes: ["leaveRequest", "materialRequest"], extras: [] },
  "osama@123": { home: "/accountant", interfaces: [], boxes: [], extras: ["invoiceStats", "workshopExpenses"] },
  "arttouch@123": { home: "/partner", interfaces: [], boxes: [], extras: ["partnerOrder", "partnerPrice"] },
  "mitham@123": { home: "/partner-mitham", interfaces: [], boxes: [], extras: [] },
  "ms.sara": { home: "/partner-sara", interfaces: [], boxes: [], extras: [] },
  "frame@123": { home: "/frame-invoices", interfaces: [], boxes: [], extras: [] },
  "karina@123": {
    home: "/karina",
    interfaces: [],
    boxes: ["myTasks", "directSale", "todo", "ordersAdmin", "canvasCost", "leaveRequest"],
    extras: [],
  },
  // الموظفات السابقات - لوحاتهم باقية مثل ما هي
  "rand@123": { home: "/rand", interfaces: [], boxes: [...INVOICE_KEYS, "myTasks", "todo", "ordersAdmin"], extras: [] },
  "jumana@123": {
    home: "/jumana",
    interfaces: [],
    boxes: ["myTasks", "siteVisit", "directSale", "leads", "todo", "ordersAdmin", "canvasCost", "leaveRequest"],
    extras: [],
  },
  "sara@123": { home: "/sara", interfaces: [], boxes: ["myTasks", "todo", "ordersAdmin", "canvasCost", "leaveRequest"], extras: [] },
  "maryam@123": {
    home: "/maryam",
    interfaces: [],
    boxes: [...INVOICE_KEYS, "siteVisit", "myTasks", "leads", "todo", "ordersAdmin", "canvasCost", "leaveRequest"],
    extras: ["priceList"],
  },
  "farah@123": {
    home: "/farah-dashboard",
    interfaces: [],
    boxes: [...INVOICE_KEYS, "siteVisit", "myTasks", "leads", "todo", "ordersAdmin", "canvasCost", "leaveRequest"],
    extras: [],
  },
  "maysa@123": {
    home: "/maysa",
    interfaces: [],
    boxes: [...INVOICE_KEYS, "siteVisit", "myTasks", "directSale", "leads", "drawingVideos", "todo", "ordersAdmin", "canvasCost", "leaveRequest"],
    extras: [],
  },
};

// حسابات الموظفات السابقات (ما انحذفن - بس ينعرضن بقسم مطوي)
export const FORMER_STAFF_ACCOUNTS = ["rand@123", "jumana@123", "sara@123", "maryam@123", "farah@123", "maysa@123"];

const boxItem = (key) => {
  const box = PERMISSION_BOXES.find((b) => b.key === key);
  return { id: `box:${key}`, kind: "box", key, label: box?.label || key, icon: box?.icon || "", paths: BOX_PATHS[key] || [] };
};

// كل الأزرار الثابتة لحساب (بشكل موحّد) - null للحسابات بدون لوحة قديمة
export const getAccountBuiltIns = (username, dashboardType) => {
  const account = dashboardType === "boxes" ? null : ACCOUNTS[username];
  if (!account) return null;
  return {
    home: account.home,
    boxes: account.boxes.map(boxItem),
    extras: account.extras.map((key) => ({ id: `extra:${key}`, kind: "extra", key, ...EXTRA_ITEMS[key] })),
    interfaces: account.interfaces.map((d) => ({
      id: `dash:${d.path}`,
      kind: "dash",
      label: d.label,
      icon: "🖥️",
      path: d.path,
      paths: [exact(d.path)],
    })),
  };
};

const readHidden = () => {
  try {
    const value = JSON.parse(localStorage.getItem("hiddenBuiltIns"));
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

// للوحة المستخدم الحالي: هل الزر الثابت هذا ظاهر؟ (المدير يشوف كلشي)
export const showBuiltIn = (id) => !readHidden().includes(id);

const matches = (item, pathname) => item.paths.some((re) => re.test(pathname));

// هل الصفحة هذي مقفولة على المستخدم الحالي لأن المدير شال زرها؟ تنقفل بس
// إذا ماكو زر ثاني ظاهر (أو بوكس ممنوح) يفتح نفس الصفحة
export const isPathHiddenForMe = (pathname) => {
  const hidden = readHidden();
  if (!hidden.length) return false;
  const { username, dashboardType } = getCurrentProfile();
  const builtIns = getAccountBuiltIns(username, dashboardType);
  if (!builtIns) return false;
  const all = [...builtIns.boxes, ...builtIns.extras, ...builtIns.interfaces];
  const hiddenMatch = all.some((item) => hidden.includes(item.id) && matches(item, pathname));
  if (!hiddenMatch) return false;
  const visibleMatch = all.some((item) => !hidden.includes(item.id) && matches(item, pathname));
  return !visibleMatch && !permissionAllowsPath(pathname);
};
